module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAESSURBVHja7NvLDoIwEIXhc4aF8f2fVZCFjAvRaHRhNEBp/0nYkCaUr/RGW2mDiIheUj5fEXHaIi/e4JlZUp6isJeXpKlKANvj90l9rg9AuiyRdk9tQJaYt7XbgOICAAAAAAAAAAAAAAAAAAAAAAAAAAAAABqLlx+PtkdLlynzWGVp20NKXWYePgFki4XvRl/+gRDzQmWbDWDEyQ2XPr0AAABIrTeCPd3g06CgJYS8j4HidaToMexqq0TY/bxTJT7OBVZQ/3meQi8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFUDZHUAYQ9LpN0NQErdEmn/DRf4aafWPdBZXP2u+vC0dNuW8rb6NN9bvUCuAAAA//8DAD4uMSpZqcLRAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/plus-black.png
// module id = Sdsf
// module chunks = 1